import React from 'react';
import { Box, Typography } from '@material-ui/core';

/**
 * Claymorphism Card Wrapper Component
 * Provides consistent card styling with color variants
 */
function ClayCard({ children, colorVariant = 'orange', title, classes, id }) {
  const cardColorClass = {
    // New Banner-matched colors
    orange: classes.clayCardOrange,
    gold: classes.clayCardGold,
    cyan: classes.clayCardCyan,
    // Legacy colors
    peach: classes.clayCardPeach,
    blue: classes.clayCardBlue,
    lilac: classes.clayCardLilac,
    mint: classes.clayCardMint,
    lightPeach: classes.clayCardLightPeach,
    lightBlue: classes.clayCardLightBlue,
    lightMint: classes.clayCardLightMint,
  }[colorVariant] || classes.clayCardOrange;

  return (
    <Box id={id} className={`${classes.clayCard} ${cardColorClass}`}>
      {title && <Typography className={classes.sectionTitle}>{title}</Typography>}
      {children}
    </Box>
  );
}

export default ClayCard;
